// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, anyOf, maybe } from "@altostra/type-validations";
import { nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

const isPostmasterComplianceStatusValue = objectOf({
  status: string,
});

const isPostmasterComplianceVerdict = objectOf({
  status: isPostmasterComplianceStatusValue,
  reason: maybe(string, true),
});

const isPostmasterDeliverabilityStatusVerdict = objectOf({
  state: isPostmasterComplianceStatusValue,
  reason: maybe(string, true),
});

const isPostmasterComplianceRowData = objectOf({
  requirement: string,
  status: isPostmasterComplianceStatusValue,
});

const isPostmasterDomainComplianceData = objectOf({
  domain_id: string,
  row_data: arrayOf(isPostmasterComplianceRowData),
  one_click_unsubscribe_verdict: isPostmasterComplianceVerdict,
  honor_unsubscribe_verdict: isPostmasterComplianceVerdict,
  deliverability_status_verdict: isPostmasterDeliverabilityStatusVerdict,
});

const isPostmasterDomainComplianceStatusResult = objectOf({
  name: string,
  compliance_data: isPostmasterDomainComplianceData,
  subdomain_compliance_data: anyOf(isPostmasterDomainComplianceData, nullOrUndefined),
});

export const isDeliverabilityPostmasterComplianceStatusResult = objectOf({
  hits: number,
  results: arrayOf(isPostmasterDomainComplianceStatusResult),
  retrieved_at: string,
});
